import { appState, resolveDefaultRelayUrl, resolveDefaultSignalUrl } from '../state';
import { renderSession } from './session';
import { loadSavedHosts, upsertHost, touchLastUsed } from '../services/address-book';
import { applyStyle, escapeHtml } from '../ui/css';
import { createCard } from '../ui/components/card';
import { createButton } from '../ui/components/button';
import { createPageHeader } from '../ui/components/pageHeader';
import { createStatusBadge, createTagBadge } from '../ui/components/badge';
import { icons } from '../ui/icons';
export function renderDevices() {
    const root = document.createElement('div');
    // Selamlama header — saat'e göre dinamik
    const greeting = greetingFor(new Date(), appState.userEmail);
    root.append(createPageHeader({
        title: greeting.title,
        highlight: greeting.highlight,
        subtitle: 'Uzak bir bilgisayara bağlan veya kendi bilgisayarını paylaşıma aç.',
        rightSlot: dateBadge(new Date()),
    }));
    // Üst grid — 2 kart yan yana (mobile'da alt alta)
    const topGrid = document.createElement('div');
    topGrid.classList.add('pr-grid-cards');
    applyStyle(topGrid, {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(360px, 1fr))',
        gap: 'var(--sp-4)',
        marginBottom: 'var(--sp-5)',
    });
    topGrid.append(buildConnectCard(root));
    topGrid.append(buildHostInstallCard());
    root.append(topGrid);
    // Cihazlarım — section header + cleanup
    const devicesSection = document.createElement('section');
    applyStyle(devicesSection, { marginBottom: 'var(--sp-5)' });
    const devicesHeader = document.createElement('div');
    applyStyle(devicesHeader, {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 'var(--sp-3)',
        marginBottom: 'var(--sp-3)',
        flexWrap: 'wrap',
    });
    const dHeaderLeft = document.createElement('div');
    dHeaderLeft.innerHTML = `
    <h2 style="margin:0;font-family:var(--font-display);font-style:italic;font-weight:500;font-size:24px">Cihazlarım</h2>
    <div style="font-size:var(--fs-caption);color:var(--text-tertiary);margin-top:2px">Tek tık ile kendi bilgisayarlarına bağlan — kod gerekmez.</div>
  `;
    devicesHeader.append(dHeaderLeft);
    const cleanupBtn = createButton({
        label: 'Eski cihazları temizle',
        variant: 'subtle',
        size: 'sm',
        iconHtml: icons.trash(),
    });
    devicesHeader.append(cleanupBtn);
    devicesSection.append(devicesHeader);
    const list = document.createElement('div');
    list.id = 'list';
    list.classList.add('pr-grid-cards');
    applyStyle(list, {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
        gap: 'var(--sp-3)',
    });
    devicesSection.append(list);
    root.append(devicesSection);
    // Sabit hostlar
    const pinnedSection = document.createElement('section');
    pinnedSection.id = 'pinned-section';
    applyStyle(pinnedSection, { marginBottom: 'var(--sp-5)', display: 'none' });
    pinnedSection.innerHTML = `
    <h3 style="margin:0 0 var(--sp-3);font-size:var(--fs-h3);font-weight:600;color:var(--text-primary);display:flex;align-items:center;gap:var(--sp-2)">
      ${icons.pin()} Sabit hostlar
    </h3>
    <div id="saved-hosts" style="display:flex;flex-wrap:wrap;gap:var(--sp-2)"></div>
  `;
    root.append(pinnedSection);
    // Paylaşılan erişimler
    const sharedSection = document.createElement('section');
    sharedSection.id = 'shared-section';
    applyStyle(sharedSection, { marginBottom: 'var(--sp-5)' });
    sharedSection.innerHTML = `
    <h3 style="margin:0 0 var(--sp-3);font-size:var(--fs-h3);font-weight:600;color:var(--text-primary)">
      Paylaşılan erişimler
    </h3>
    <div id="shared-list"></div>
  `;
    root.append(sharedSection);
    const msg = document.createElement('div');
    msg.id = 'msg';
    applyStyle(msg, {
        fontSize: 'var(--fs-caption)',
        color: 'var(--text-secondary)',
        marginTop: 'var(--sp-2)',
        minHeight: '18px',
    });
    root.append(msg);
    const sharedList = sharedSection.querySelector('#shared-list');
    const savedHostsDiv = pinnedSection.querySelector('#saved-hosts');
    // Pinned hosts UI
    const pinned = loadSavedHosts(appState.userEmail).filter(h => h.pinned);
    if (pinned.length > 0) {
        pinnedSection.style.display = 'block';
        savedHostsDiv.innerHTML = pinned.map(h => `
      <button class="saved-host" data-hid="${escapeHtml(h.humanId)}"
              style="padding:8px 14px;background:var(--bg-elev-2);border:1px solid var(--border-subtle);
                     border-radius:var(--radius-pill);color:var(--text-primary);cursor:pointer;
                     display:inline-flex;align-items:center;gap:6px;font-size:var(--fs-caption)">
        ${icons.pin()} ${escapeHtml(h.nickname)}
        <code style="opacity:0.6;font-family:var(--font-mono);font-size:11px">${escapeHtml(h.humanId)}</code>
      </button>
    `).join('');
        savedHostsDiv.querySelectorAll('.saved-host').forEach(b => {
            b.addEventListener('click', () => {
                const hid = b.getAttribute('data-hid');
                const inp = root.querySelector('#humanId');
                if (inp)
                    inp.value = hid;
                const code = root.querySelector('#code');
                code?.focus();
            });
        });
    }
    // Address book pending connect
    const pending = localStorage.getItem('photon.pending_connect');
    if (pending) {
        localStorage.removeItem('photon.pending_connect');
        const inp = root.querySelector('#humanId');
        if (inp)
            inp.value = pending;
    }
    async function startSession(result, sourceHumanId) {
        let monitorIndex = 0;
        try {
            const monitors = await appState.backend.getDeviceMonitors(result.deviceId);
            if (monitors.length > 1) {
                const picked = await pickMonitor(monitors);
                if (picked === null)
                    return;
                monitorIndex = picked;
            }
        }
        catch { /* no monitors fetched → primary */ }
        touchLastUsed(appState.userEmail, sourceHumanId);
        const app = document.getElementById('app');
        if (!app)
            return;
        app.innerHTML = '';
        const jwt = appState.accessToken ?? '';
        const relayUrl = resolveDefaultRelayUrl();
        const signalUrl = resolveDefaultSignalUrl();
        result.monitorIndex = monitorIndex;
        app.append(renderSession(result, jwt, relayUrl, signalUrl));
    }
    // Cihazlar — backend'den çek + presence
    (async () => {
        try {
            const devices = await appState.backend.listDevices();
            const hosts = devices.filter(d => !d.displayName.startsWith('PhotonRemote Web'));
            list.replaceChildren(...renderDeviceTiles(hosts));
            const presencePromises = hosts.map(async (d) => {
                try {
                    const r = await fetch(`${appState.backendUrl}/devices/${d.deviceId}/presence`, {
                        headers: { 'Authorization': `Bearer ${appState.accessToken ?? ''}` },
                    });
                    if (!r.ok)
                        return null;
                    return await r.json();
                }
                catch {
                    return null;
                }
            });
            const presences = await Promise.all(presencePromises);
            hosts.forEach((d, i) => {
                const card = list.querySelector(`[data-device-id="${escapeAttr(d.deviceId)}"]`);
                if (!card)
                    return;
                const badge = card.querySelector('[data-badge]');
                const connectBtn = card.querySelector('[data-connect]');
                const verLine = card.querySelector('[data-version]');
                const p = presences[i];
                if (!badge || !connectBtn)
                    return;
                badge.replaceChildren();
                if (!p) {
                    badge.append(createStatusBadge('offline', 'bilinmiyor'));
                }
                else if (p.status === 'sharing') {
                    badge.append(createStatusBadge('busy', 'paylaşımda'));
                    connectBtn.disabled = false;
                    if (verLine && p.agentVersion)
                        verLine.textContent = `host-agent v${p.agentVersion}`;
                }
                else if (p.status === 'online') {
                    badge.append(createStatusBadge('online', 'çevrimiçi'));
                    connectBtn.disabled = false;
                    if (verLine && p.agentVersion)
                        verLine.textContent = `host-agent v${p.agentVersion}`;
                }
                else {
                    badge.append(createStatusBadge('offline', 'çevrimdışı'));
                    connectBtn.disabled = true;
                    connectBtn.title = 'Host-agent çevrimdışı — PC açık mı?';
                }
            });
            list.querySelectorAll('[data-connect]').forEach(b => {
                b.addEventListener('click', async () => {
                    const deviceId = b.getAttribute('data-connect');
                    const hid = b.getAttribute('data-hid');
                    const original = b.textContent;
                    b.disabled = true;
                    b.textContent = 'bağlanıyor...';
                    msg.textContent = '';
                    try {
                        const result = await appState.backend.connectAuthorize(deviceId);
                        await startSession(result, hid);
                    }
                    catch (e) {
                        msg.textContent = `${e}`;
                        b.textContent = original;
                        b.disabled = false;
                    }
                });
            });
            list.querySelectorAll('[data-add-book]').forEach(b => {
                b.addEventListener('click', () => {
                    const hid = b.getAttribute('data-hid');
                    const name = b.getAttribute('data-name');
                    upsertHost(appState.userEmail, {
                        id: crypto.randomUUID(),
                        nickname: name, humanId: hid,
                        notes: '', pinned: false,
                        createdAt: new Date().toISOString(),
                    });
                    alert('✓ Adres defterine eklendi');
                });
            });
        }
        catch (e) {
            msg.textContent = `Hata: ${e}`;
        }
    })();
    // Paylaşılan erişimler
    (async () => {
        try {
            const entries = await appState.backend.getAddressBook();
            const shared = entries.filter(e => e.kind !== 0);
            sharedList.innerHTML = renderSharedList(shared);
            sharedList.querySelectorAll('[data-connect-did]').forEach(b => {
                b.addEventListener('click', async () => {
                    const deviceId = b.getAttribute('data-connect-did');
                    const hid = b.getAttribute('data-hid') ?? '';
                    b.disabled = true;
                    const orig = b.textContent;
                    b.textContent = 'bağlanıyor...';
                    try {
                        const result = await appState.backend.connectAuthorize(deviceId);
                        await startSession(result, hid);
                    }
                    catch (e) {
                        msg.textContent = `${e}`;
                        b.disabled = false;
                        b.textContent = orig;
                    }
                });
            });
            sharedList.querySelectorAll('[data-manual-hid]').forEach(b => {
                b.addEventListener('click', () => {
                    const hid = b.getAttribute('data-manual-hid');
                    const humanInput = root.querySelector('#humanId');
                    if (humanInput)
                        humanInput.value = hid;
                    root.querySelector('#code')?.focus();
                });
            });
        }
        catch {
            sharedList.innerHTML = '';
        }
    })();
    cleanupBtn.addEventListener('click', async () => {
        if (!confirm('30 günden fazla çevrimdışı host cihazların arşivlenecek (kalıcı silme değil). Devam?'))
            return;
        cleanupBtn.disabled = true;
        const orig = cleanupBtn.querySelector('span').textContent;
        cleanupBtn.querySelector('span').textContent = 'temizleniyor...';
        msg.textContent = '';
        try {
            const r = await appState.backend.cleanupStaleDevices(30);
            msg.textContent = r.revokedCount === 0
                ? `Son ${r.dayThreshold} gündür çevrimdışı cihaz yok.`
                : `${r.revokedCount} cihaz arşivlendi (>${r.dayThreshold} gün). Liste güncelleniyor...`;
            if (r.revokedCount > 0) {
                setTimeout(() => appState.refresh(), 600);
            }
        }
        catch (e) {
            msg.textContent = `Temizlik hata: ${e}`;
        }
        finally {
            cleanupBtn.disabled = false;
            cleanupBtn.querySelector('span').textContent = orig ?? 'Eski cihazları temizle';
        }
    });
    return root;
}
// ─────────────────────────────────────────────────────────────────────────
// Yardımcı bileşenler
function buildConnectCard(rootRef) {
    const card = createCard({
        caption: 'PARTNER · 9 hane',
        title: 'Uzak Bilgisayarı Kontrol Et',
        subtitle: 'Karşıdaki kişinin sana verdiği 9-haneli ID + 6-haneli pairing kodu.',
    });
    const form = document.createElement('div');
    applyStyle(form, { display: 'flex', flexDirection: 'column', gap: 'var(--sp-3)', marginTop: 'var(--sp-3)' });
    form.innerHTML = `
    <label style="display:flex;flex-direction:column;gap:6px;font-size:var(--fs-tiny);letter-spacing:0.12em;color:var(--text-tertiary);font-weight:500">
      PARTNER ID
      <input id="humanId" placeholder="847 293 516" autocapitalize="none" autocorrect="off" spellcheck="false"
             style="padding:14px 16px;font-size:22px;font-family:var(--font-mono);letter-spacing:0.08em;
                    background:var(--bg-elev-3);border:1px solid var(--border-strong);
                    border-radius:var(--radius-sm);color:var(--text-primary)" />
    </label>
    <label style="display:flex;flex-direction:column;gap:6px;font-size:var(--fs-tiny);letter-spacing:0.12em;color:var(--text-tertiary);font-weight:500">
      PAIRING KODU (6 hane)
      <input id="code" placeholder="123 456" autocapitalize="none" autocorrect="off" spellcheck="false" inputmode="numeric"
             style="padding:12px 16px;font-size:18px;font-family:var(--font-mono);letter-spacing:0.08em;
                    background:var(--bg-elev-3);border:1px solid var(--border-strong);
                    border-radius:var(--radius-sm);color:var(--text-primary)" />
    </label>
  `;
    card.append(form);
    const btnRow = document.createElement('div');
    applyStyle(btnRow, { display: 'flex', gap: 'var(--sp-2)', marginTop: 'var(--sp-3)' });
    const connect = createButton({
        label: 'Bağlan',
        variant: 'primary',
        size: 'lg',
        fullWidth: true,
        iconHtml: icons.arrowRight(),
        iconRight: true,
    });
    connect.id = 'connect';
    btnRow.append(connect);
    card.append(btnRow);
    // Bağlan butonu altı görünür hata/durum kutusu — silently fail eden eski
    // davranış (#msg element yoktu, hata kayboluyordu) düzeltildi.
    const statusBox = document.createElement('div');
    applyStyle(statusBox, {
        marginTop: 'var(--sp-3)',
        fontSize: 'var(--fs-caption)',
        minHeight: '20px',
        color: 'var(--text-tertiary)',
        display: 'none',
    });
    card.append(statusBox);
    function setStatus(text, kind = 'info') {
        statusBox.textContent = text;
        statusBox.style.display = text ? 'block' : 'none';
        statusBox.style.color = kind === 'error'
            ? 'var(--status-error)'
            : kind === 'ok'
                ? 'var(--accent)'
                : 'var(--text-tertiary)';
    }
    connect.addEventListener('click', async () => {
        setStatus('');
        try {
            const humanId = (rootRef.querySelector('#humanId'))?.value.trim().replace(/\s/g, '') ?? '';
            const code = (rootRef.querySelector('#code'))?.value.trim().replace(/\s/g, '') ?? '';
            if (!humanId || !code) {
                setStatus('Partner ID ve pairing kodu gerekli.', 'error');
                return;
            }
            connect.disabled = true;
            setStatus('Bağlantı kuruluyor…');
            const result = await appState.backend.consumePairing(humanId, code);
            setStatus('Bağlandı, oturum başlatılıyor…', 'ok');
            // startSession scope dışında — page-level event delegation yerine direct.
            const ev = new CustomEvent('pr-pairing-result', { detail: { result, humanId } });
            document.dispatchEvent(ev);
        }
        catch (e) {
            const errMsg = e?.message ?? String(e);
            // Backend mesajını parse et: "pairing failed: 401 {...}" → durum koduna göre özel anlam
            let friendly = errMsg;
            if (errMsg.includes('401')) {
                friendly = 'Partner ID veya pairing kodu hatalı / süresi doldu. Masaüstü ekranındaki güncel kodu kontrol et.';
            }
            else if (errMsg.includes('429')) {
                friendly = 'Çok fazla başarısız deneme. 60 sn bekleyip tekrar dene.';
            }
            else if (errMsg.includes('Failed to fetch') || errMsg.includes('NetworkError')) {
                friendly = 'Sunucuya ulaşılamadı. İnternet bağlantını kontrol et.';
            }
            setStatus(friendly, 'error');
            connect.disabled = false;
        }
    });
    // Pairing event'i dinle — startSession'ı tetikle.
    document.addEventListener('pr-pairing-result', async (e) => {
        const detail = e.detail;
        const app = document.getElementById('app');
        if (!app)
            return;
        let monitorIndex = 0;
        try {
            const monitors = await appState.backend.getDeviceMonitors(detail.result.deviceId);
            if (monitors.length > 1) {
                const picked = await pickMonitor(monitors);
                if (picked === null)
                    return;
                monitorIndex = picked;
            }
        }
        catch { }
        touchLastUsed(appState.userEmail, detail.humanId);
        app.innerHTML = '';
        detail.result.monitorIndex = monitorIndex;
        app.append(renderSession(detail.result, appState.accessToken ?? '', resolveDefaultRelayUrl(), resolveDefaultSignalUrl()));
    }, { once: true });
    return card;
}
function buildHostInstallCard() {
    const card = createCard({
        caption: 'BU BİLGİSAYAR',
        title: 'Uzaktan kontrole izin ver',
        subtitle: 'Host ajanını kur — bu PC kendi cihaz listende görünür ve sen tek-tık ile bağlanırsın.',
    });
    const stage = document.createElement('div');
    applyStyle(stage, {
        display: 'flex',
        flexDirection: 'column',
        gap: 'var(--sp-3)',
        marginTop: 'var(--sp-3)',
    });
    const link = document.createElement('a');
    link.href = '/download/PhotonRemote-Host-Setup.exe';
    link.setAttribute('download', '');
    applyStyle(link, {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 'var(--sp-3)',
        padding: 'var(--sp-4)',
        background: 'var(--bg-elev-3)',
        border: '1px solid var(--border-strong)',
        borderRadius: 'var(--radius-md)',
        color: 'var(--text-primary)',
        textDecoration: 'none',
        transition: 'border-color var(--motion-fast), background var(--motion-fast)',
    });
    link.addEventListener('mouseenter', () => {
        link.style.borderColor = 'var(--accent)';
        link.style.background = 'var(--accent-soft)';
    });
    link.addEventListener('mouseleave', () => {
        link.style.borderColor = 'var(--border-strong)';
        link.style.background = 'var(--bg-elev-3)';
    });
    link.innerHTML = `
    <div style="display:flex;align-items:center;gap:var(--sp-3)">
      <span style="display:flex;width:40px;height:40px;align-items:center;justify-content:center;background:var(--accent-soft);color:var(--accent);border-radius:var(--radius-sm)">
        ${icons.download()}
      </span>
      <div style="display:flex;flex-direction:column;gap:2px">
        <span style="font-weight:600;font-size:var(--fs-body)">Host kurulumu indir</span>
        <span style="font-size:var(--fs-caption);color:var(--text-tertiary)">PhotonRemote-Host-Setup.exe · 4.1 MB</span>
      </div>
    </div>
    <span style="color:var(--accent);display:flex">${icons.arrowRight()}</span>
  `;
    stage.append(link);
    const tips = document.createElement('div');
    applyStyle(tips, {
        display: 'flex',
        flexDirection: 'column',
        gap: '6px',
        fontSize: 'var(--fs-caption)',
        color: 'var(--text-tertiary)',
        paddingTop: 'var(--sp-2)',
        borderTop: '1px solid var(--border-subtle)',
        marginTop: 'var(--sp-2)',
    });
    tips.innerHTML = `
    <div>• Kurulum sonrası bu kullanıcıyla giriş yap — PC otomatik bağlanır.</div>
    <div>• "Cihazlarım" listesinde görünür; tek-tık bağlanma için kod gerekmez.</div>
    <div>• Pairing kodu, sadece başkasına geçici erişim verirken gerekir.</div>
  `;
    stage.append(tips);
    card.append(stage);
    return card;
}
function renderDeviceTiles(devices) {
    if (devices.length === 0) {
        const empty = document.createElement('div');
        applyStyle(empty, {
            gridColumn: '1 / -1',
            padding: 'var(--sp-7)',
            textAlign: 'center',
            color: 'var(--text-tertiary)',
            background: 'var(--bg-elev-2)',
            border: '1px dashed var(--border-strong)',
            borderRadius: 'var(--radius-md)',
        });
        empty.innerHTML = `
      <div style="font-size:32px;margin-bottom:var(--sp-3)">🖥</div>
      <div style="font-size:var(--fs-body);color:var(--text-secondary);max-width:380px;margin:0 auto">
        Henüz kayıtlı host bilgisayarın yok. PC'ye PhotonRemote kur ve bu hesapla giriş yap — bu listede görünecek.
      </div>
    `;
        return [empty];
    }
    return devices.map(d => {
        const tile = document.createElement('article');
        tile.dataset.deviceId = d.deviceId;
        applyStyle(tile, {
            background: 'var(--bg-elev-2)',
            border: '1px solid var(--border-subtle)',
            borderRadius: 'var(--radius-md)',
            padding: 'var(--sp-4)',
            display: 'flex',
            flexDirection: 'column',
            gap: 'var(--sp-3)',
            transition: 'border-color var(--motion-fast), transform var(--motion-fast)',
        });
        tile.addEventListener('mouseenter', () => {
            tile.style.borderColor = 'var(--accent)';
        });
        tile.addEventListener('mouseleave', () => {
            tile.style.borderColor = 'var(--border-subtle)';
        });
        const head = document.createElement('div');
        applyStyle(head, { display: 'flex', alignItems: 'center', gap: 'var(--sp-3)' });
        const ic = document.createElement('div');
        ic.innerHTML = icons.monitor();
        applyStyle(ic, {
            width: '40px',
            height: '40px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'var(--bg-elev-3)',
            borderRadius: 'var(--radius-sm)',
            color: 'var(--accent)',
            flexShrink: '0',
        });
        head.append(ic);
        const meta = document.createElement('div');
        applyStyle(meta, { display: 'flex', flexDirection: 'column', minWidth: '0', flex: '1' });
        const name = document.createElement('div');
        name.textContent = d.displayName;
        applyStyle(name, {
            fontWeight: '600',
            fontSize: 'var(--fs-body)',
            color: 'var(--text-primary)',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
        });
        const sub = document.createElement('div');
        sub.textContent = d.os;
        applyStyle(sub, { fontSize: 'var(--fs-tiny)', color: 'var(--text-tertiary)' });
        meta.append(name, sub);
        head.append(meta);
        if (d.unattended) {
            const tag = createTagBadge('UNATTENDED', 'accent');
            head.append(tag);
        }
        tile.append(head);
        // Human ID + presence
        const idRow = document.createElement('div');
        applyStyle(idRow, {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 'var(--sp-2)',
            padding: '8px 0',
        });
        const idText = document.createElement('code');
        idText.textContent = formatHumanId(d.humanId);
        applyStyle(idText, {
            fontFamily: 'var(--font-mono)',
            fontSize: 'var(--fs-caption)',
            letterSpacing: '0.06em',
            color: 'var(--text-secondary)',
        });
        idRow.append(idText);
        const badgeWrap = document.createElement('div');
        badgeWrap.setAttribute('data-badge', '');
        badgeWrap.append(createStatusBadge('offline', 'kontrol ediliyor...'));
        idRow.append(badgeWrap);
        tile.append(idRow);
        const ver = document.createElement('div');
        ver.setAttribute('data-version', '');
        applyStyle(ver, { fontSize: 'var(--fs-tiny)', color: 'var(--text-tertiary)', minHeight: '14px' });
        tile.append(ver);
        // Aksiyon
        const actions = document.createElement('div');
        applyStyle(actions, { display: 'flex', gap: 'var(--sp-2)', marginTop: 'auto', paddingTop: 'var(--sp-2)' });
        const connect = createButton({
            label: 'Bağlan',
            variant: 'primary',
            size: 'sm',
            iconHtml: icons.arrowRight(),
            iconRight: true,
            fullWidth: true,
            attrs: { 'data-connect': d.deviceId, 'data-hid': d.humanId },
            disabled: true,
        });
        actions.append(connect);
        const addBook = createButton({
            label: '',
            variant: 'subtle',
            size: 'sm',
            iconHtml: icons.users(),
            attrs: { 'data-add-book': '', 'data-hid': d.humanId, 'data-name': d.displayName, title: 'Adres defterine ekle' },
        });
        actions.append(addBook);
        tile.append(actions);
        return tile;
    });
}
function renderSharedList(entries) {
    if (entries.length === 0) {
        return `<div style="padding:var(--sp-5);background:var(--bg-elev-2);border:1px dashed var(--border-subtle);border-radius:var(--radius-md);color:var(--text-tertiary);font-size:var(--fs-caption);text-align:center">
      Başka kullanıcıların sana kalıcı erişim verdiği cihazlar veya manuel humanId ile eklediğin hedefler burada görünür.
    </div>`;
    }
    return `<div style="display:grid;grid-template-columns:repeat(auto-fill, minmax(320px, 1fr));gap:var(--sp-3)">` +
        entries.map(e => {
            const kindLabel = e.kind === 1 ? 'KALICI İZİN' : 'MANUEL';
            const kindColor = e.kind === 1 ? 'var(--status-info)' : '#a78bfa';
            const nameLine = escapeHtml(e.nickname || e.displayName || 'İsimsiz');
            const hidLine = e.targetHumanId ? formatHumanId(e.targetHumanId) : '';
            const canDirectConnect = e.kind === 1 && e.targetDeviceId;
            const btnHtml = canDirectConnect
                ? `<button data-connect-did="${escapeAttr(e.targetDeviceId)}"
                  data-hid="${escapeAttr(e.targetHumanId ?? '')}"
                  style="padding:8px 14px;background:var(--accent);color:var(--on-accent);border:0;border-radius:var(--radius-sm);cursor:pointer;font-weight:600;font-size:var(--fs-caption)">
             Bağlan →
           </button>`
                : `<button data-manual-hid="${escapeAttr(e.targetHumanId ?? '')}"
                  style="padding:8px 14px;background:transparent;color:var(--text-primary);border:1px solid var(--border-strong);border-radius:var(--radius-sm);cursor:pointer;font-weight:500;font-size:var(--fs-caption)">
             Kod ile bağlan
           </button>`;
            return `
        <article style="background:var(--bg-elev-2);border:1px solid var(--border-subtle);border-radius:var(--radius-md);padding:var(--sp-4);display:flex;flex-direction:column;gap:var(--sp-2)">
          <div style="display:flex;align-items:center;justify-content:space-between;gap:var(--sp-2)">
            <strong style="font-size:var(--fs-body);color:var(--text-primary)">${nameLine}</strong>
            <span style="font-size:var(--fs-tiny);color:${kindColor};letter-spacing:0.08em;font-weight:600">${kindLabel}</span>
          </div>
          ${hidLine ? `<code style="font-family:var(--font-mono);font-size:var(--fs-caption);color:var(--text-secondary)">${escapeHtml(hidLine)}</code>` : ''}
          ${e.notes ? `<div style="font-size:var(--fs-caption);color:var(--text-tertiary);font-style:italic">${escapeHtml(e.notes)}</div>` : ''}
          <div style="margin-top:auto;padding-top:var(--sp-2)">${btnHtml}</div>
        </article>`;
        }).join('') +
        `</div>`;
}
// ─────────────────────────────────────────────────────────────────────────
// Yardımcı fonksiyonlar
function pickMonitor(monitors) {
    return new Promise((resolve) => {
        const dlg = document.createElement('div');
        applyStyle(dlg, {
            position: 'fixed',
            inset: '0',
            background: 'rgba(10,14,26,0.78)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: '1000',
            backdropFilter: 'blur(4px)',
        });
        dlg.innerHTML = `
      <div style="background:var(--bg-elev-2);padding:var(--sp-5);border-radius:var(--radius-lg);min-width:420px;border:1px solid var(--border-subtle);box-shadow:var(--shadow-elev)">
        <h2 style="margin:0 0 var(--sp-3);font-family:var(--font-display);font-style:italic;font-size:24px">Hangi monitör?</h2>
        <div id="mon-list" style="display:flex;flex-direction:column;gap:var(--sp-2)">
          ${monitors.map((m, i) => `
            <button data-i="${i}" style="display:flex;width:100%;padding:12px 14px;text-align:left;cursor:pointer;background:var(--bg-elev-3);border:1px solid var(--border-subtle);border-radius:var(--radius-sm);color:var(--text-primary);align-items:center;gap:var(--sp-2)">
              <span style="color:var(--accent);font-size:14px">${m.primary ? '★' : '○'}</span>
              <span>Monitör ${m.index}</span>
              <span style="margin-left:auto;font-family:var(--font-mono);font-size:var(--fs-caption);color:var(--text-tertiary)">${m.width}×${m.height}</span>
            </button>
          `).join('')}
        </div>
        <button id="mon-cancel" style="margin-top:var(--sp-3);padding:8px 14px;background:transparent;border:1px solid var(--border-strong);border-radius:var(--radius-sm);color:var(--text-secondary);cursor:pointer">İptal</button>
      </div>
    `;
        document.body.appendChild(dlg);
        dlg.querySelectorAll('[data-i]').forEach(b => {
            b.addEventListener('click', () => {
                dlg.remove();
                resolve(Number(b.getAttribute('data-i')));
            });
        });
        dlg.querySelector('#mon-cancel').addEventListener('click', () => {
            dlg.remove();
            resolve(null);
        });
    });
}
function greetingFor(d, email) {
    const hour = d.getHours();
    const name = email ? email.split('@')[0] : '';
    let greet = 'Merhaba';
    if (hour < 6)
        greet = 'İyi geceler';
    else if (hour < 11)
        greet = 'Günaydın';
    else if (hour < 14)
        greet = 'İyi öğlenler';
    else if (hour < 18)
        greet = 'İyi günler';
    else
        greet = 'İyi akşamlar';
    return { title: greet + ',', highlight: capitalize(name) || 'PhotonRemote' };
}
function capitalize(s) {
    return s ? s[0].toUpperCase() + s.slice(1) : '';
}
function dateBadge(d) {
    const div = document.createElement('div');
    applyStyle(div, {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        gap: '2px',
        fontSize: 'var(--fs-caption)',
        color: 'var(--text-tertiary)',
        letterSpacing: '0.06em',
    });
    const days = ['PAZAR', 'PAZARTESİ', 'SALI', 'ÇARŞAMBA', 'PERŞEMBE', 'CUMA', 'CUMARTESİ'];
    const months = ['OCAK', 'ŞUBAT', 'MART', 'NİSAN', 'MAYIS', 'HAZİRAN', 'TEMMUZ', 'AĞUSTOS', 'EYLÜL', 'EKİM', 'KASIM', 'ARALIK'];
    div.innerHTML = `
    <span>${days[d.getDay()]} · ${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()}</span>
    <span style="font-family:var(--font-mono);font-size:var(--fs-h3);color:var(--text-secondary);letter-spacing:0.08em">
      ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}
    </span>
  `;
    return div;
}
function formatHumanId(id) {
    const clean = id.replace(/\s+/g, '');
    if (clean.length <= 3)
        return clean;
    return clean.match(/.{1,3}/g)?.join(' ') ?? clean;
}
function escapeAttr(s) {
    return s.replace(/[&<>"']/g, c => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
    }[c]));
}
